export default __webpack_public_path__ + "static/media/Audio type.b5a13980.svg";